import React, {Component} from 'react';
import couterpart from 'counterpart';
import { withRouter } from 'react-router-dom';
import {ToastsContainer, ToastsStore} from 'react-toasts';

import '../css/style.css';
import { ICON_COLOR } from '../icon';
import { FaPrint } from 'react-icons/fa';

class OrderPrint extends Component {
    constructor() {
        super();
        this.state = {
            workOrders: []
        };
        sessionStorage.setItem("orderIds", []);
    };

    printOrders(){
        if (this.props.ids === undefined || this.props.ids === null || this.props.ids.length <1){
            return;
        }

        var ids = [];
        for(var prop in this.props.ids) {
            if (this.props.ids[prop] === true){
                ids.push(prop);
            }  
        }

        if (ids === undefined || ids === null || ids.length <1){
            ToastsStore.error(couterpart.translate('msg_print_preview_info'));
            return;
        }

        sessionStorage.setItem("orderIds", ids);
        this.props.history.push("/orders/print");
    }
      
    render() {
        const button_print_preview = couterpart.translate('button_print_preview');
        return(
        <div style={{padding:"0px"}}>
            <ToastsContainer store={ToastsStore} position="bottom_center" />
            <button className="myButton" 
                onClick={this.printOrders.bind(this)}>
                    <FaPrint color={ICON_COLOR}/>
                &nbsp;{button_print_preview}
            </button>
        </div>
        );
    }
}

export default withRouter(OrderPrint);